import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

function VerifyCodePage({ email }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!code.match(/^\d{8}$/)) {
      setError("Please enter the 8-digit code sent to your email.");
      return;
    }
    try {
      const response = await fetch("https://api.dev1.auth.joeandalese.com/v1/validate-login-code", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ email, code })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data.error || data.message || "Verification failed. Try again.");
        return;
      }
      // Redirect to home, cookie will be sent automatically
      navigate("/home");
    } catch (err) {
      setError("Network error. Please try again.");
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "80px auto", padding: 24, border: "1px solid #eee", borderRadius: 8, boxShadow: "0 2px 8px #f0f1f2" }}>
      <h2 style={{ textAlign: "center" }}>Verify Email</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="code">8-Digit Code</label>
        <input
          id="code"
          type="text"
          value={code}
          onChange={e => setCode(e.target.value)}
          style={{ width: "100%", padding: 8, margin: "8px 0 16px 0", borderRadius: 4, border: "1px solid #ccc" }}
          required
          autoFocus
          maxLength={8}
        />
        {error && <div style={{ color: "#d32f2f", marginBottom: 8 }}>{error}</div>}
        <button type="submit" style={{ width: "100%", padding: 10, background: "#1976d2", color: "#fff", border: "none", borderRadius: 4 }}>Verify</button>
      </form>
    </div>
  );
}

export default VerifyCodePage;
